import { Document, Font, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
// @ts-expect-error Import
import ManropeRegular from '../../../../../theme/assets/fonts/Manrope-Regular.ttf';
// @ts-expect-error Import
import ManropeBold from '../../../../../theme/assets/fonts/Manrope-Bold.ttf';
// @ts-expect-error Import
import ManropeMedium from '../../../../../theme/assets/fonts/Manrope-Medium.ttf';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PdfCompanyLogo, PdfCompanyTitle, pdfStyles } from '../../../../../components';
import { CustomerReportResponse } from '../../../../../interfaces/reports.interface';
import { CustomerReportPdfTrader } from './CustomerReportPdfTrader';
import { CustomerReportTableSectionPdf } from './CustomerReportTableSectionPdf';

interface Props {
  data: CustomerReportResponse;
  logo: string | null | undefined;
}

// Register Font
Font.register({
  family: 'Manrope',
  fonts: [
    {
      src: ManropeRegular,
    },
    {
      src: ManropeMedium,
    },
    {
      src: ManropeBold,
    },
  ],
});

export const CustomerReportPdf = ({ data, logo }: Props) => {
  const { t } = useTranslation();

  const getTitle = useCallback(() => {
    return (
      <View style={styles.title}>
        <Text style={pdfStyles.headerTitle}>{t('CUSTOMERS_REPORT.CUSTOMER_REPORT')}</Text>
      </View>
    );
  }, [t]);

  const getSection = useCallback(() => {
    return (
      <View style={styles.section}>
        <View>
          <View style={pdfStyles.flexStartSpaceRow}>
            <PdfCompanyTitle company={data?.params?.company} />
            <PdfCompanyLogo logo={logo} />
          </View>
          <View style={{ paddingTop: 4 }} />
          {getTitle()}
          <CustomerReportPdfTrader data={data} />
          <View style={{ paddingTop: 4 }} />
          <CustomerReportTableSectionPdf data={data} />
        </View>
      </View>
    );
  }, [data, getTitle, logo]);

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        {getSection()}
        <View style={styles.footer} fixed>
          <Text style={pdfStyles.smallestTitle}>{t('PDF.BY_BILLEASE')}</Text>
        </View>
      </Page>
    </Document>
  );
};

const styles = StyleSheet.create({
  section: {
    margin: 10,
    padding: 10,
    marginTop: 0,
    paddingTop: 0,
    marginBottom: 20,
    flexGrow: 1,
    justifyContent: 'space-between',
  },
  title: {
    textDecoration: 'underline',
    justifyContent: 'center',
    alignItems: 'center',
  },
  page: {
    fontFamily: 'Manrope',
    fontSize: 12,
    flexDirection: 'column',
    backgroundColor: 'white',
    paddingTop: 30,
    paddingBottom: 10,
  },
  footer: {
    left: 20, // Adjust left margin to match page padding
    bottom: 0, // Adjust bottom margin to match page padding
    fontSize: 10,
    alignItems: 'flex-start',
  },
});
